<template>
  <div class="brand-checker-page">
    <BrandTool :active-tab="2">
      <div class="brand-checker">
        <BrandNameInput
            label="Enter your brand name"
            :class="['brand-checker__brand-input-wrapper']"
            :brand-name-form-error="formErrors.brandName"
            @value-updated="updateBrandNameValue"
        />

        <TrademarkFinder
            :categories="filteredCategories"
            @trademark-search-updated="searchCategories"
            @selected-trademarks-updated="updateSelectedTrademarks"
        />

        <CheckerSearchOptions
          :search-options-form-error="formErrors.searchOptions"
          @trademark-updated="updateTrademarkValue"
          @uk-trademark-updated="updateTrademarkValueUK"
          @eu-trademark-updated="updateTrademarkValueEU"
          @us-trademark-updated="updateTrademarkValueUS"
          @social-media-updated="updateSocialMediaValue"
          @social-media-users-updated="updateSocialMediaUsersValue"
          @social-media-mentions-updated="updateSocialMediaMentionsValue"
          @social-media-twitter-updated="updateSocialMediaTwitterValue"
          @social-media-facebook-updated="updateSocialMediaFacebookValue"
          @social-media-instagram-updated="updateSocialMediaInstagramValue"
          @domain-search-updated="updateDomainValue"
          @domain-hypenate-updated="updateDomainHypenateValue"
          @domain-industry-updated="updateDomainIndustryValue"
          @web-search-updated="updateWebSearchValue"
        />

        <CheckerReferralTool
            @referral-updated="updateReferralValue"
            :hasReferred="hasReferred"
        />

        <button
            type="button"
            class="btn"
            @click="handleSubmit($event)"
            :disabled="
            !(brandName && isUKTrademarkSearch) &&
            !(brandName && isUSTrademarkSearch) &&
            !(brandName && isEUTrademarkSearch) &&
            !(
              brandName &&
              (socialMediaSearch ||
                socialMediaUsersSearch ||
                socialMediaMentionsSearch ||
                socialMediaTwitterSearch ||
                socialMediaFacebookSearch ||
                socialMediaInstagramSearch)
            ) &&
            !(brandName && domainSearch) &&
            !(brandName && webSearch)
          "
        >
          Submit
        </button>

        <CheckerLoadingProgress
            v-if="isSearching"
            :percentage="searchPercentage"
        />
        <CheckerSearchResults
          v-else-if="searchToken"
          :results="searchResults"
          :search-token="searchToken"
          :showUKTrademarkResults="isUKTrademarkSearch"
          :showEUTrademarkResults="isEUTrademarkSearch"
          :showUSTrademarkResults="isUSTrademarkSearch"
          :show-web-results="webSearch"
          :show-social-results="socialMediaSearch && socialMediaMentionsSearch"
          :show-social-user-results="
            socialMediaSearch && socialMediaUsersSearch
          "
            :show-domain-results="domainSearch"
            :social-bool="socialbool"
        />

        <CheckerExportOptions
          v-if="!isSearching && searchToken && searchResults"
          :search-token="searchToken"
          :uk-trademark-search="isUKTrademarkSearch"
          :us-trademark-search="isUSTrademarkSearch"
          :eu-trademark-search="isEUTrademarkSearch"
          :social-search="socialMediaSearch"
          :social-mentions-search="socialMediaMentionsSearch"
          :social-users-search="socialMediaUsersSearch"
          :domain-search="domainSearch"
          :web-search="webSearch"
        />
      </div>
    </BrandTool>
  </div>
</template>

<script setup>
import ApiMixin from "../../mixins/apiMixin";
import {ref, onMounted, computed, provide} from "vue";
import {useStore} from "vuex-composition-helpers";
import BrandTool from "@/components/layout/BrandTool";
import TrademarkFinder from "@/views/BrandChecker/TrademarkFinder";
import CheckerSearchOptions from "@/views/BrandChecker/CheckerSearchOptions";
import CheckerSearchResults from "@/views/BrandChecker/CheckerSearchResults";
import BrandNameInput from "@/views/BrandChecker/BrandNameInput";
import CheckerExportOptions from "@/views/BrandChecker/CheckerExportOptions";
import CheckerLoadingProgress from "@/views/BrandChecker/CheckerLoadingProgess";
import CheckerReferralTool from "@/views/BrandChecker/CheckerReferralTool";
import axios from "axios";
// import { useRouter } from "vue-router";

const store = useStore();

const brandName = ref();
const selectedCategories = ref([]);
const filteredCategories = ref([]);
const isTrademarkSearch = ref(false);
const isEUTrademarkSearch = ref(false);
const isUKTrademarkSearch = ref(false);
const isUSTrademarkSearch = ref(false);
const shouldRefer = ref(false);
const hasReferred = ref(false);
const socialMediaSearch = ref(false);
const socialMediaUsersSearch = ref(false);
const socialMediaMentionsSearch = ref(false);
const socialMediaTwitterSearch = ref(false);
const socialMediaFacebookSearch = ref(false);
const socialMediaInstagramSearch = ref(false);
const domainSearch = ref(false);
const domainHypenateSearch = ref(false);
const domainIndustrySearch = ref("");
const webSearch = ref(false);
const isSearching = ref(false);
const searchToken = ref(null);
const searchPercentage = ref(0);
const searchResults = ref({});
const formErrors = ref({
  brandName: {
    error: false,
    text: "Brand Name is required",
  },
  searchOptions: {
    error: false,
    text: "Please select a search option",
  },
});
let timer = null;

function updateTrademarkValue(value) {
  isTrademarkSearch.value = value;

  if (isTrademarkSearch.value) {
    formErrors.value.searchOptions.error = false;
  }
}

function updateReferralValue(value) {
  shouldRefer.value = value;
}

function updateTrademarkValueUK(value) {
  isUKTrademarkSearch.value = value;
}

function updateTrademarkValueUS(value) {
  isUSTrademarkSearch.value = value;
}


function updateTrademarkValueEU(value) {
  isEUTrademarkSearch.value = value;
}

function updateSocialMediaValue(value) {
  socialMediaSearch.value = value;
  // console.log("socialMediaSearch:", socialMediaSearch.value);

  if (socialMediaSearch.value) {
    formErrors.value.searchOptions.error = false;
  }
}

function updateSocialMediaUsersValue(value) {
  socialMediaUsersSearch.value = value;
  // console.log("socialMediaUsersSearch:", socialMediaUsersSearch.value);
}

function updateSocialMediaMentionsValue(value) {
  socialMediaMentionsSearch.value = value;
  // console.log("socialMediaMentionsSearch:", socialMediaMentionsSearch.value);
}

function updateSocialMediaTwitterValue(value) {
  // console.log("twitter value:", value);
  socialMediaTwitterSearch.value = value;
  // console.log("socialMediaTwitterSearch:", socialMediaTwitterSearch.value);
}

function updateSocialMediaFacebookValue(value) {
  // console.log("facebook value:", value);
  socialMediaFacebookSearch.value = value;
  // console.log("socialMediaFacebookSearch:", socialMediaFacebookSearch.value);
}

function updateSocialMediaInstagramValue(value) {
  // console.log("insta value:", value);
  socialMediaInstagramSearch.value = value;
  // console.log("socialMediaInstagramSearch:", socialMediaInstagramSearch.value);
}

function updateDomainValue(value) {
  domainSearch.value = value;
  // console.log("domainSearch:", domainSearch.value);

  if (domainSearch.value) {
    formErrors.value.searchOptions.error = false;
  }
}

function updateDomainHypenateValue(value) {
  domainHypenateSearch.value = value;
}

function updateDomainIndustryValue(value) {
  domainIndustrySearch.value = value;
}

function updateWebSearchValue(value) {
  webSearch.value = value;

  if (webSearch.value) {
    formErrors.value.searchOptions.error = false;
  }
}

function updateBrandNameValue(value) {
  brandName.value = value;

  if (brandName.value) {
    formErrors.value.brandName.error = false;
  }
}

const jobTypes = computed(() => {
  let data = [];

  console.log(isUSTrademarkSearch.value, isEUTrademarkSearch.value, isUKTrademarkSearch.value);
  if (isUKTrademarkSearch.value) data.push("trademark_search");

  if (isEUTrademarkSearch.value) data.push("euipo_search");

  if (isUSTrademarkSearch.value) data.push("usipo_search");

  if (domainSearch.value) data.push("domain_search");

  if (socialMediaSearch.value) data.push("social_search");

  if (socialMediaUsersSearch.value) data.push("social_users_search");

  if (webSearch.value) data.push("web_search");

  return data;
});

const brandBank = computed(() => {
  return store.state.BrandCentre.brandBank;
});

const storedBrandName = computed(() => {
  return store.getters["BrandChecker/getBrandNameString"];
});

onMounted(() => {
  getCreds();
  store.dispatch("BrandCentre/getProjects");

  if (storedBrandName.value) {
    brandName.value = storedBrandName.value;
  }
});

function validateForm() {
  if (!brandName.value) {
    formErrors.value.brandName.error = true;
    return false;
  }

  if (
      !isTrademarkSearch.value &&
      !socialMediaSearch.value &&
      !domainSearch.value &&
      !webSearch.value
  ) {
    formErrors.value.searchOptions.error = true;
    return false;
  }

  return true;
}

function updateSelectedTrademarks(data) {
  selectedCategories.value = data;
}

async function searchCategories(data) {
  filteredCategories.value = await ApiMixin.methods.searchTrademarkCategories(
      data
  );
}

const socialbool = ref(false);

// calculate needed credits

const calculateTotalCreditsRequired = () => {
  if (
    isUKTrademarkSearch.value ||
    isEUTrademarkSearch.value ||
    isUSTrademarkSearch.value ||
    domainSearch.value ||
    socialMediaSearch.value ||
    socialMediaUsersSearch.value ||
    webSearch.value
  ) {
    return 1;
  } else {
    return 0;
  }

  // console.log("isUKTrademarkSearch:", isUKTrademarkSearch.value);
  // console.log("isEUTrademarkSearch:", isEUTrademarkSearch.value);
  // console.log("domainSearch:", domainSearch.value);
  // console.log("socialMediaSearch:", socialMediaSearch.value);
  // console.log("socialMediaUsersSearch:", socialMediaUsersSearch.value);
  // console.log("webSearch:", webSearch.value);
  // console.log("totalCredits:", totalCredits);

  // return totalCredits;
};

async function getCreds() {
  try {
    const response = await axios.post(
        `${process.env.VUE_APP_API_ROOT_URL}/api/getCredits`,
        {
          userId: sessionStorage.getItem("user_id"),
        }
    );

    // check if a user can perform a search
    if (response.data.credits === 0) {
      window.location.href = "/my-account/manage-plan/top-up";
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function handleSubmit() {
  const creditsRequired = calculateTotalCreditsRequired();

  // console.log(creditsRequired);
  const getCreds = await axios({
    method: "post",
    url: `${process.env.VUE_APP_API_ROOT_URL}/api/getCredits`,
    data: {
      userId: sessionStorage.getItem("user_id"),
    },
    headers: {
      "Content-Type": "application/json",
    },
  });

  // if (getCreds.data.credits < creditsRequired) {
  if (getCreds.data.credits < creditsRequired) {
    window.location.href = "/no-credits";
    return false;
  }

  await axios({
    method: "post",
    url: `${process.env.VUE_APP_API_ROOT_URL}/api/removeCredits`,
    data: {
      userId: sessionStorage.getItem("user_id"),
      credits: creditsRequired,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
  socialbool.value = socialMediaSearch.value;

  if (shouldRefer.value && !hasReferred.value) {
    let referral = await ApiMixin.methods.sendReferral();
    console.log(referral);
    hasReferred.value = true;
  }

  if (!validateForm()) {
    return false;
  }

  searchResults.value = {};
  isSearching.value = true;

  // console.log("real twitter:", socialMediaTwitterSearch.value);
  const response = await ApiMixin.methods.dekonstruktSearch({
    user_id: sessionStorage.getItem("user_id"),
    job_type: jobTypes.value.toString(),
    social_search_options: {
      users: socialMediaUsersSearch.value,
      mentions: socialMediaMentionsSearch.value,
      // Set them all to true
      twitter: true,
      instagram: true,
      facebook: true,
      // Get real options
      real_twitter: socialMediaTwitterSearch.value,
      real_instagram: socialMediaInstagramSearch.value,
      real_facebook: socialMediaFacebookSearch.value,
    },
    domain_search_options: {
      hyphenate: domainHypenateSearch.value,
      industry: domainIndustrySearch.value,
    },
    search_type: "dekonstruktor",
    keyword: brandName.value,
    trademark_cat: [
      ...new Set(selectedCategories.value.map((cat) => cat.class)),
    ],
  });

  searchToken.value = response.data.search_token;

  timer = setInterval(getStatus, 2000);

  if (
      !brandBank.value.some(
          (brandData) =>
              brandData.name.toLowerCase() === brandName.value.toLowerCase()
      )
  ) {
    store.dispatch("BrandCentre/addWordToBrandBank", brandName.value);
  }
}

async function getStatus() {
  const statusResponse = await ApiMixin.methods.getSearchStatus(
      searchToken.value
  );
  // console.log('statusResponse :>> ', statusResponse);

  if (statusResponse.percentage > searchPercentage.value) {
    searchPercentage.value = statusResponse.percentage;
  } else if (searchPercentage.value < 100) {
    // console.log("updating by 1");
    searchPercentage.value += 2;
  }


  if (searchPercentage.value >= 100) {
    // console.log("search percentage is at 100");
    clearInterval(timer);
    timer = null;
    isSearching.value = false;
    searchPercentage.value = 0;

    const result = await ApiMixin.methods.dekonstruktResult(searchToken.value);
    searchResults.value = result.data;
  }
}

provide("real_twitter", socialMediaTwitterSearch);
provide("real_instagram", socialMediaInstagramSearch);
provide("real_facebook", socialMediaFacebookSearch);
</script>
